export default __webpack_public_path__ + "static/media/quick_action_dialog_import_uplaod.ef27cd07.svg";